export default __webpack_public_path__ + "c4af52f53368b81cc3ea577f37f9a916.woff2";